import { useMatch } from '@reach/router';

import { ROUTES } from '@xing-com/crate-jobs-paths';

export const useIsAiSearch = (): boolean => {
  const isAiSearchUrl = !!useMatch(ROUTES.searchAi);

  return isAiSearchUrl;
};
